import { CommonButton } from "../../Input";

const TopUpSuccess = ({ onBackHome }) => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "75vh" }}
    >
      <div
        className="text-center bg-white p-5 rounded-4 shadow-none"
        style={{ maxWidth: "1000px", width: "100%" }}
      >
        <div className="mb-4">
          <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60C46.5585 60 60 46.5685 60 30C60 13.4315 46.5585 0 30 0ZM24 45L9 30L13.242 25.758L24 36.5145L46.758 13.758L51 18L24 45Z"
              fill="#10B981"
            />
          </svg>
        </div>
        <h3 className="fw-bold text-success mb-3 fs-24">
          Transaction Created Successfully!
        </h3>
        <p className="text-muted mb-4 fs-14">
          Your transaction has been processed successfully. You can now
          download, print, or email the receipt.
        </p>

        <div className="d-flex justify-content-center gap-3 mt-4 pt-2">
          <CommonButton variant="primary" onClick={onBackHome}>
            Close
          </CommonButton>
        </div>
      </div>
    </div>
  );
};

export default TopUpSuccess;
